export const SurveyPage = {
	One: 1,
	Two: 2,
};
Object.freeze(SurveyPage);
